import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { MemoryRouter } from 'react-router-dom';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import axios from 'axios';
import { QueryClient, QueryClientProvider } from 'react-query';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
import { Provider } from 'react-redux';
import { propertiesMapReducer } from './redux/propertiesMap';
import * as AppConstants from './AppConstants';
import { toast } from 'react-toastify';

import { createStore } from 'redux';
import './custom.css';

const store = createStore(
  propertiesMapReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__(),
);

const rootElement = document.getElementById('root');

axios.defaults.baseURL = AppConstants.BASE_URL;
axios.defaults.headers.common = {
  ApiKey: AppConstants.API_KEY,
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  accepts: 'application/json',
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24,
    },
  },
});

if (typeof window !== 'undefined') {
  const localStoragePersistor = createWebStoragePersistor({
    storage: window.localStorage,
  });

  persistQueryClient({
    queryClient,
    persistor: localStoragePersistor,
  });
}

axios.interceptors.request.use(
  (request) => {
    console.log(`${request.method} ${request.url}`);
    console.log(`${request.headers.Authorization} ${request}`);
    console.log('request', request);

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    console.log('response', response);
    // Edit response config
    return response;
  },
  (error) => {
    console.log(error);
    if (error.response.status === 401) {
      //Unathorized, redirect to login
      localStorage.clear();
      window.location.reload();
    } else {
      // toast.error(`Internal Server Error, please contact support.`, {
      //   position: 'top-center',
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   draggable: false,
      //   progress: undefined,
      // });
    }
    return Promise.reject(error);
  },
);

ReactDOM.render(
  <QueryClientProvider client={queryClient} contextSharing={true}>
    <MemoryRouter>
      <Provider store={store}>
        <App />
      </Provider>
      ,
    </MemoryRouter>
  </QueryClientProvider>,
  rootElement,
);

unregisterServiceWorker();
